import React, { useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { Link } from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { useSelector } from 'react-redux';

function ComTemplateSave({ templateArr, setTemplateArr, close }) {
  const { user } = useSelector((state) => state.auth);
  const [templateListArr, setTemplateListArr] = useState(templateArr || []);
  const [tempMsgString, setTempMsgString] = useState('');
  const [templetId, setTempletId] = useState(false);
  const [conFirmDelete, setConFirmDelete] = useState({ status: false, id: 0 });

  const handleTemplateSave = async () => {
    if (tempMsgString !== '') {
      try {
        const response = await post(
          'api/communication/Communication/addTemplateInMaster',
          {
            temlateText: tempMsgString,
            loginUserId: user?.id,
          }
        );

        if (response.status === 200) {
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Template save successfully.');
            setTemplateListArr(response?.data?.allShortMsg);
            setTemplateArr(response?.data?.allShortMsg);
            setTempMsgString('');
          } else if (response?.data?.status === 'already') {
            setUiMessage('war', 'Template already exist.');
          } else {
            setUiMessage('err', 'Somthing went wrong... template not save.');
          }
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      }
    } else {
      setUiMessage('err', 'Message is empty!');
    }
  };
  const handleTemplateUpdate = async () => {
    if (tempMsgString !== '') {
      try {
        const response = await post(
          'api/communication/Communication/updateTemplate',
          {
            temlateId: templetId,
            temlateText: tempMsgString,
            loginUserId: user?.id,
          }
        );

        if (response.status === 200) {
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Template update successfully.');
            setTemplateListArr(response?.data?.allShortMsg);
            setTemplateArr(response?.data?.allShortMsg);
            setTempMsgString('');
            setTempletId(false);
          } else if (response?.data?.status === 'already') {
            setUiMessage('war', 'Template already exist.');
          } else {
            setUiMessage('err', 'Somthing went wrong... template not save.');
          }
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      }
    } else {
      setUiMessage('err', 'Message is empty!');
    }
  };

  const handleChangeTemplet = (id) => {
    let text = templateListArr.find((item, i) => item.id === id);
    setTempMsgString(text?.template_msg);
    setTempletId(id);
  };

  const handleDeleteTemplet = (id) => {
    setConFirmDelete((prev) => ({ ...prev, status: true, id: id }));
  };

  const handleDeleteTempletConfirm = async (id) => {
    try {
      const response = await post(
        'api/communication/Communication/deleteTemplate',
        {
          temlateId: id,
          loginUserId: user?.id,
        }
      );

      if (response.status === 200) {
        if (response?.data?.status === 'success') {
          setUiMessage('suc', 'Template delete successfully.');
          setTemplateListArr(response?.data?.allShortMsg);
          setTemplateArr(response?.data?.allShortMsg);
          setConFirmDelete((prev) => ({ ...prev, status: false }));
        } else {
          setUiMessage('err', 'Somthing went wrong... template not delete.');
        }
      }
    } catch (err) {
      setUiMessage('suc', err.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="compose-msg-main-con grid-sec tab-bg ">
        <div className="comp-msg-hdr flex-sec">Add Template</div>
        <div className="comp-msg-bdy grid-sec">
          <div className="comp-msg-bdy-rw flex-sec">
            <span className="msg-bdy-rw-bl">Message:</span>
            <span className="msg-bdy-rw-val">
              <textarea
                className="msg-bdy"
                placeholder="Write your Message here"
                onChange={(e) => {
                  if (e.target.value.length <= 320)
                    setTempMsgString(e.target.value);
                }}
                value={tempMsgString}
              ></textarea>
              <span>{`${
                320 - tempMsgString.length
              } - Character Remains `}</span>
            </span>
          </div>
        </div>
        <div className="comp-msg-ftr flex-sec">
          {(templetId && (
            <button className="actn-yes" onClick={handleTemplateUpdate}>
              Update
            </button>
          )) || (
            <button className="actn-yes" onClick={handleTemplateSave}>
              Save
            </button>
          )}
          <button className="actn-No" onClick={close}>
            Cancel
          </button>
        </div>
        <div className="com-temp-body-hdr comp-msg-hdr flex-sec">
          <span className="label">Templates</span>
          <span className="label-2">Action</span>
        </div>

        <div className="com-temp-body">
          {templateListArr &&
            templateListArr?.map((item, i) => (
              <div
                key={i}
                className={`com-temp-body-row ${i % 2 === 0 ? 'alt-rw' : ''}`}
              >
                <span className="bdy-label">{item?.template_msg}</span>
                <span className="bdy-label-2">
                  <Link onClick={() => handleChangeTemplet(item?.id)}>
                    Change
                  </Link>{' '}
                  <br />
                  <Link onClick={() => handleDeleteTemplet(item?.id)}>
                    Delete
                  </Link>
                </span>
              </div>
            ))}
        </div>
      </div>
      {conFirmDelete?.status && (
        <ConfirmDialog
          title="Confirm"
          bodytext="Do you want to delete this templet?"
          sucPrams={conFirmDelete?.id}
          closeDialog={() =>
            setConFirmDelete((prev) => ({ ...prev, status: false }))
          }
          successDialog={handleDeleteTempletConfirm}
        />
      )}
    </div>
  );
}

export default ComTemplateSave;
